import { TranslationSectionView } from "./TranslationSectionView";

export function TranslationSectionContainer() {
  return <TranslationSectionView />;
}
